import { render, staticRenderFns } from "./BaseFormCard.vue?vue&type=template&id=43614ee8"
import script from "./BaseFormCard.vue?vue&type=script&setup=true&lang=ts"
export * from "./BaseFormCard.vue?vue&type=script&setup=true&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports